import { Injectable } from '@angular/core';
import { WebApiService } from '../../../../shared/services/web-api.service';
import { RfqTokenAuthService } from 'src/app/shared/services/rfq-token-auth.service';

@Injectable({
  providedIn: 'root'
})
export class RfqGenerateFormService {

  constructor(
    private webApiService: WebApiService,
    private rfqTokenAuth: RfqTokenAuthService
    ) { }

  getAllSubcategories(categoryId: any): Promise<any> {
    let apiUrl = `/impa/fetchSubCategoryDetails/${categoryId}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  getRfqItem(rfqId:number): Promise<any> {
    let apiUrl = `/rfq/cart/getSelectedCartItemsForRfq/${rfqId}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  getImpaCatalogue(categoryId: any): Promise<any> {
    let apiUrl = `/impa/fetchDetails`;
    return this.webApiService.postRequest<any>(apiUrl, {
      categoryIds: categoryId
    });
  }

  saveRfq(rfqId: number, headerData: any, lineItemData: any, paymentTermsData: any,lineItemTableData:any): Promise<any> {
    let apiUrl = `/rfq/save/`;
    return this.webApiService.postRequest<any>(apiUrl, {
      metaData: {
        rfqId
      },
      headerData,
      lineItemData,
      paymentTermsData,
      lineItemTableData
    });
  }

  getLeafNodeFromCategoryId(subcategoryId: any): Promise<any> {
    let apiUrl = `/impa/fetchLeafNodeFromCategoryId/${subcategoryId}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  getAllpaymentTerms():Promise<any>{ 
    let apiUrl = `/rfq/getAllpaymentTerms`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  getAllpaymentTermsByRfqToken():Promise<any>{ 
    let apiUrl = `/rfq/getAllpaymentTermsByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }

  fetchSupplierRfqListRequiredData(params:any):Promise<any>{ 
    let apiUrl = `/rfq/fetchSupplierRfqListRequiredData`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

  getAllSuppliersForCartItem(impaId:number):Promise<any>{
    let apiUrl = `/rfq/fetchsupplierDetails/${impaId}`;
    return this.webApiService.getRequest<any>(apiUrl)

  }

  getSuggestedSupplierByImpaId(params: any): Promise<any> {
    let apiUrl = `/rfq/getSuggestedSupplierByImpaId`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  getMySupplierByBuyerId(params: any): Promise<any> {
    let apiUrl = `/rfq/getMySupplierByBuyerId`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  getRFQDraftData(tab:string,buyerId:number):Promise<any>{
    let apiUrl = `/rfq/getRfqDraftData/${tab}/${buyerId}`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  getRfqDraftTab4Data(rfqDetailsId: number): Promise<any> {
    let apiUrl = `/rfq/getRfqDraftTab4/${rfqDetailsId}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  getRfqDraftAllData(rfqDetailsId: number, tab:string): Promise<any> {
    // Section-scoped read: fetch ONLY the requested tab (getRfqDraftData/:tab/:id
    // returns {rows} -> the raw array the preview consumes). The combined
    // getRfqDraftAll endpoint returned all three sections in one payload, which
    // blew past the Lambda 6MB/timeout limit for large line-item RFQs (502) and
    // never matched the component's per-tab array shape.
    let apiUrl = `/rfq/getRfqDraftData/${tab}/${rfqDetailsId}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  getSuggestedSuppliersByImpaIds(params: { rfqId: number; impaIds: number[]; buyerCountry: string }): Promise<any> {
    let apiUrl = `/rfq/getSuggestedSuppliersByImpaIds`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }


  saveRfqAsDraft(params: any): Promise<any> {
    let apiUrl = `/rfq/saveAsdraft`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  createRfq(params: any): Promise<any> {
    let apiUrl = `/rfq/createRfq`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  updateRfqAsDraft(params: any): Promise<any> {
    let apiUrl = `/rfq/updateRfqDraft`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  deleteRfqAttachment(reqBody: any): Promise<any> {
    let apiUrl = `/rfq/deleteRfqAttachment`;
    return this.webApiService.postRequest<any>(apiUrl, reqBody);
  }

  deleteRfqLineItem(reqBody: any): Promise<any> {
    let apiUrl = `/rfq/deleteRfqLineItem`;
    return this.webApiService.postRequest<any>(apiUrl, reqBody);
  }

  getPreviousLineItemAttachments(reqBody: any): Promise<any> {
    let apiUrl = `/rfq/getPreviousLineItemAttachments`;
    return this.webApiService.postRequest<any>(apiUrl, reqBody);
  }

  getCompareSupplierQuotes(reqBody: { rfqId: number; quoteIds: number[] }): Promise<any> {
    let apiUrl = `/rfq/getCompareSupplierQuotes`;
    return this.webApiService.postRequest<any>(apiUrl, reqBody);
  }


  getSupplierDetails(rfqId:number, productId:number):Promise<any>{
    let apiUrl = `/rfq/getSupplierDetails/${rfqId}/${productId}`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  
  getSupplierPaymentDetails(rfdDetailsId:number):Promise<any>{
    let apiUrl = `/rfq/getSupplierPaymentDetails/${rfdDetailsId}`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  
  async sendRfqAcknowledgment(params:any):Promise<any>{
    let apiUrl = `/rfq/sendRfqAcknowledgment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

  async reSendRfqAcknowledgment(params:any):Promise<any>{
    let apiUrl = `/rfq/reSendRfqAcknowledgment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

  verifyRfqToken(token: string): Promise<any> {
    let apiUrl = `/rfq/verify-rfq-token`;
    return this.webApiService.postRequest<any>(apiUrl, { token: (token || '').trim() });
  }

  async sendRfq(params:any):Promise<any>{
    let apiUrl = `/rfq/sendRfq`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

  async uploadRfqAttachment(params:any):Promise<any>{
    let apiUrl = `/rfq/uploadRfqAttachment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

  
  getlastRfqId():Promise<any>{
    let apiUrl = `/rfq/getlastRfqId`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  // Service RFQ - AI Suggested Suppliers
  getServiceSuggestedSuppliers(params: any): Promise<any> {
    let apiUrl = `/services/rfq/getServiceSuggestedSuppliers`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  // Service RFQ - Add Services to RFQ (from "Add More Services" modal)
  addServicesToServiceRfq(params: { serviceRfqId: number; serviceIds: number[] }): Promise<any> {
    let apiUrl = `/services/rfq/addServicesToRfq`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  // Service RFQ - Save Line Items and Supplier Assignments (Combined)
  saveServiceRfqLineItemsAndSuppliers(params: {
    serviceRfqId: number;
    tabId?: number;
    currencyId?: number;
    serviceCategory?: string;
    serviceType?: string;
    buyerGeneralComments?: string;
    lineItems: any[];
    supplierAssignments: any[];
  }): Promise<any> {
    let apiUrl = `/services/rfq/saveLineItemsAndSuppliers`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  // Service RFQ - Get Supplier Assignments
  getSupplierAssignments(serviceRfqId: number): Promise<any> {
    let apiUrl = `/services/rfq/getSupplierAssignments/${serviceRfqId}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  // Service RFQ - Get Payment Terms Data
  getServiceRfqPaymentTerms(serviceRfqId: number): Promise<any> {
    let apiUrl = `/services/rfq/getPaymentTerms/${serviceRfqId}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  // Service RFQ - Save Payment Terms Data
  saveServiceRfqPaymentTerms(params: any): Promise<any> {
    let apiUrl = `/services/rfq/savePaymentTerms`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  //import shipserv RFQ APIs
  extractPdf(params:any): Promise<any> {
    let apiUrl = `/rfq/extractDataFromRfqImportPdf`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  /**
   * Same import from a spreadsheet. The API returns the identical shape the
   * PDF extractor returns, so the preview dialog and every step after it are
   * shared rather than duplicated per file format.
   */
  extractExcel(params:any): Promise<any> {
    let apiUrl = `/rfq/extractDataFromRfqImportExcel`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  /**
   * Contact details for every supplier an RFQ went to. Fetched on demand: the
   * buyer list row carries a supplier count but no phone numbers, and widening
   * the shared list procedure to carry them would cost every page load.
   */
  /**
   * Removes the shell an abandoned import left behind. Safe to call blind: the
   * API refuses anything that is not an empty draft belonging to the caller.
   */
  discardEmptyImportedRfq(params:any): Promise<any> {
    let apiUrl = `/rfq/discardEmptyImportedRfq`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  getRfqSupplierContacts(params:any): Promise<any> {
    let apiUrl = `/rfq/getRfqSupplierContacts`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  /**
   * 2026-10-20: the buyer's own RFQ as an .xlsx in the layout the RFQ Excel
   * import reads, so it can be re-imported or shared. The API checks the RFQ
   * belongs to the session buyer and returns { fileName, contentType, base64 }.
   */
  exportRfqExcel(rfqId: number): Promise<any> {
    let apiUrl = `/rfq/exportRfqExcel/${encodeURIComponent(String(rfqId))}`;
    return this.webApiService.getRequest1<any>(apiUrl);
  }

  /** Buyer sessions only: the userRole cookie is 'Owner' for a buyer (same allow-list as BuyerGuard). */
  isBuyerRole(role: string | null | undefined): boolean {
    return String(role || '').trim().toLowerCase() === 'owner';
  }

  /** Snack-bar text for a failed export. A 403 never reaches here: the interceptor treats it as a dead session. */
  rfqExportErrorMessage(error: any): string {
    if (error?.status === 413) {
      return error?.error?.errors?.[0]?.message || 'This RFQ is too large to export in one file.';
    }
    if (error?.status === 404) return 'This RFQ could not be found.';
    return 'The RFQ could not be exported. Please try again.';
  }

  /**
   * Fetches the export and hands it to the browser as a download. Returns the
   * API's { lineCount, truncated } so the caller can say when only the first
   * 5,000 lines were exported.
   */
  async downloadRfqExcelExport(rfqId: number): Promise<{ lineCount: number; truncated: boolean }> {
    const res: any = await this.exportRfqExcel(rfqId);
    if (!res || typeof res.base64 !== 'string' || !res.base64.length) {
      throw new Error('The export returned no file');
    }
    const binary = atob(res.base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    const blob = new Blob([bytes], {
      type: res.contentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    // The API already sanitises the name; this keeps the download safe either way.
    const fileName = /^[A-Za-z0-9._-]{1,120}\.xlsx$/.test(res.fileName || '')
      ? res.fileName
      : `RFQ-${Number(rfqId) || 'export'}-import.xlsx`;
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return { lineCount: Number(res.lineCount) || 0, truncated: res.truncated === true };
  }

  /**
   * Deep-dive review of an extracted third-party RFQ. Read-only: it reports
   * what the import would do so the buyer can check it while the RFQ is still
   * a draft. Nothing is written by this call.
   */
  reviewImportedRfq(params:any): Promise<any> {
    let apiUrl = `/rfq/reviewImportedRfq`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  createProductsFromImportedRfq(params:any): Promise<any> {
    let apiUrl = `/rfq/createProductsFromImportedRfq`;
    return this.webApiService.postRequest<any>(apiUrl, params);
  }

  addSupplierByBuyerFromImportedRfq(_supplierDetail: any, supplierId?: any): Promise<any> {
    let apiUrl = `/rfq/addSupplierByBuyerFromImportedRfq`;
    return this.webApiService.postRequest<any>(apiUrl,  { ..._supplierDetail, supplierId });
  }

  createRfqFromImportedRfq(params: any): Promise<any> {
    let apiUrl = `/rfq/createRfqFromImportedRfq`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  updateImportedRfqAsDraft(params: any): Promise<any> {
    let apiUrl = `/rfq/updateImportedRfqAsDraft`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  createRfqFromSuggestedRfq(params: any): Promise<any> {
    let apiUrl = `/rfq/createRfqFromSuggestedRfq`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }
  
}
